import Rete from 'rete'

import CONST_SOCKET from '../../const/socket'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import FacebookMediaTemplate from './FacebookMediaTemplate'
import { lang } from '../../assets/lang'

export default class FacebookMediaComponent extends Rete.Component {
  constructor(config) {
    super(CONST_COMPONENT.FACEBOOK_MEDIA)

    this.data.component = FacebookMediaTemplate
    this.socket = config ? config.sockets : null
    this.isUserInputFlowAddonAvailable = !! window.xitFlowBuilderData.user_input_flow_addon
  }

  builder(node) {
    node.lingualName = lingualName.FACEBOOK_MEDIA
    this.setConnection()

    const facebookMediaInput = new Rete.Input(
      CONST_SOCKET.FACEBOOK_MEDIA_INPUT, 
      lang.facebook_media_socket_input_reply, 
      this.socket.facebookMediaInput,
      true
    )

    const facebookMediaOutput = new Rete.Output(
      CONST_SOCKET.FACEBOOK_MEDIA_OUTPUT, 
      lang.facebook_media_socket_output_next, 
      this.socket.facebookMediaOutput,
      false
    )

    const facebookMediaOutputButton = new Rete.Output(
      CONST_SOCKET.FACEBOOK_MEDIA_OUTPUT_BUTTON, 
      lang.facebook_media_socket_output_buttons, 
      this.socket.facebookMediaOutputButton, 
      true
    )

    const facebookMediaOutputQuickreply = new Rete.Output(
      CONST_SOCKET.FACEBOOK_MEDIA_OUTPUT_QUICKREPLY, 
      lang.facebook_media_socket_output_quick_replies, 
      this.socket.facebookMediaOutputQuickreply, 
      true
    )

    return node
      .addInput(facebookMediaInput)
      .addOutput(facebookMediaOutput)
      .addOutput(facebookMediaOutputButton)
      .addOutput(facebookMediaOutputQuickreply)
  }

  // eslint-disable-next-line
  worker(node, inputs, outputs) {
    outputs[CONST_SOCKET.FACEBOOK_MEDIA_OUTPUT] = node.data
    outputs[CONST_SOCKET.FACEBOOK_MEDIA_OUTPUT_BUTTON] = node.data
  }
  
  setConnection() {
    // FacebookMedia may take connections from:
    this.socket.facebookMediaInput.combineWith(this.socket.referenceOutput)
    this.socket.facebookMediaInput.combineWith(this.socket.newPostbackOutput)
    this.socket.facebookMediaInput.combineWith(this.socket.textOutput)
    this.socket.facebookMediaInput.combineWith(this.socket.carouselOutput)
    this.socket.facebookMediaInput.combineWith(this.socket.facebookMediaOutput)
    this.socket.facebookMediaInput.combineWith(this.socket.imageOutput)
    this.socket.facebookMediaInput.combineWith(this.socket.videoOutput)
    this.socket.facebookMediaInput.combineWith(this.socket.audioOutput)
    this.socket.facebookMediaInput.combineWith(this.socket.fileOutput)
    this.socket.facebookMediaInput.combineWith(this.socket.ecommerceOutput)
    this.socket.facebookMediaInput.combineWith(this.socket.genericTemplateOutput)
    this.socket.facebookMediaInput.combineWith(this.socket.otnOutput)

    // FacebookMedia may be connected to:
    this.socket.facebookMediaOutput.combineWith(this.socket.textInput)
    this.socket.facebookMediaOutput.combineWith(this.socket.carouselInput)
    this.socket.facebookMediaOutput.combineWith(this.socket.facebookMediaInput)
    this.socket.facebookMediaOutput.combineWith(this.socket.imageInput)
    this.socket.facebookMediaOutput.combineWith(this.socket.videoInput)
    this.socket.facebookMediaOutput.combineWith(this.socket.audioInput)
    this.socket.facebookMediaOutput.combineWith(this.socket.fileInput)
    this.socket.facebookMediaOutput.combineWith(this.socket.ecommerceInput)
    this.socket.facebookMediaOutput.combineWith(this.socket.genericTemplateInput)
    this.socket.facebookMediaOutput.combineWith(this.socket.otnInput)
    this.socket.facebookMediaOutput.combineWith(this.socket.componentListInput)

    if (this.isUserInputFlowAddonAvailable) {
      this.socket.facebookMediaOutput.combineWith(this.socket.userInputFlowInput)
    }

    // FacebookMedia Output: QuickReply, Buttons
    this.socket.facebookMediaOutputButton.combineWith(this.socket.buttonInput)
    this.socket.facebookMediaOutputQuickreply.combineWith(this.socket.quickReplyInput) 
  }
}